import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, List, ListItem } from "@mui/material";

// Shown at Save time whenever this save's KOT print would put new work in
// front of the kitchen (a line added this session, or an existing line's
// quantity raised above what it started at) — names exactly what's about to
// print so the waiter isn't sending items to the kitchen by surprise.
export default function KotConfirmDialog({ open, items, onCancel, onConfirm }) {
  return (
    <Dialog open={open} onClose={onCancel} fullWidth maxWidth="xs">
      <DialogTitle>Send new items to the kitchen?</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" gutterBottom>
          These items will be printed on the KOT:
        </Typography>
        <List dense sx={{ py: 0 }}>
          {(items || []).map((item, i) => (
            <ListItem key={i} sx={{ py: 0.25, px: 0, display: "list-item", listStyleType: "disc", ml: 2.5 }}>
              <Typography variant="body2">
                {item.name} × {item.qty}
              </Typography>
            </ListItem>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>Cancel</Button>
        <Button variant="contained" onClick={onConfirm}>
          Send to Kitchen
        </Button>
      </DialogActions>
    </Dialog>
  );
}
